import xss from 'xss'

// sanitizes strings to protect from xss attacks
export const safeGuardString = ( string: unknown ) => ( xss( String( string ) ) )
